// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__ngDTv","input":"SearchBar_input__gMoru","inputBorder":"SearchBar_inputBorder__3Krmn"};